module.exports = __webpack_public_path__ + "static/media/categories-logo-shopify.f8e4f5ea.svg";